module.exports = __webpack_public_path__ + "static/media/need-kids.f059ed3e.jpg";